/**
 * Event table shared type definitions and enum-like constants.
 *
 * @class EventTableTypes
 * @name types
 * @memberof Mojito.Modules.EventTable
 */
export default class EventTableTypes {}

/**
 * Business-oriented column content types used by the event table.
 *
 * @readonly
 * @enum {string}
 * @memberof Mojito.Modules.EventTable.types
 */
EventTableTypes.COLUMN_TYPES = {
    /** Standing position within the table. */
    RANK: 'rank',
    /** Betting odds / market price column. */
    ODDS: 'odds',
    /** Total standings points. */
    STANDING_POINTS: 'points',
    /** Participant identity cell, typically flag/icon plus team name. */
    PARTICIPANT: 'countryCode',
};

/**
 * Display value used for standings rows when a market price is not available.
 *
 * @readonly
 * @type {string}
 * @memberof Mojito.Modules.EventTable.types
 */
EventTableTypes.MISSING_ODDS_DISPLAY = '-';
